/**
 * KROQ — pilotage des vidéos de fond.
 *
 * Trois responsabilités, aucune dépendance :
 *   1. prefers-reduced-motion : la vidéo n'est jamais lancée.
 *   2. Chargement différé hors du premier écran (IntersectionObserver).
 *   3. Contrôle pause/lecture (WCAG 2.2.2).
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /** Pose la source d'une vidéo restée vide et démarre la lecture. */
  function activate(video) {
    if (!video || video.dataset.kroqVideoReady === 'true') return;
    video.dataset.kroqVideoReady = 'true';

    var src = video.dataset.kroqVideoSrc;
    if (src && !video.querySelector('source')) {
      var source = document.createElement('source');
      source.src = src;
      source.type = 'video/mp4';
      video.appendChild(source);
      video.load();
    }

    if (!reduceMotion.matches) play(video);
  }

  function play(video) {
    var attempt = video.play();
    // Safari rejette la promesse si l'onglet est en arrière-plan : sans
    // catch, l'erreur remonte en console non gérée.
    if (attempt && typeof attempt.catch === 'function') attempt.catch(function () {});
  }

  /** Exécute après le chargement complet, sans jamais rester en attente. */
  function afterLoad(fn) {
    var lance = false;
    var go = function () {
      if (lance) return;
      lance = true;
      // Un tour de boucle de plus : le navigateur finit sa peinture avant
      // qu'on lui donne une vidéo à télécharger.
      if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 2000 });
      else setTimeout(fn, 200);
    };
    if (document.readyState === 'complete') go();
    else window.addEventListener('load', go, { once: true });
    // Filet : si `load` tarde (une image tierce qui traîne), on n'attend pas
    // indéfiniment pour animer le hero.
    setTimeout(go, 5000);
  }

  function setToggleState(root, paused) {
    var toggle = root.querySelector('[data-kroq-video-toggle]');
    if (!toggle) return;
    toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');

    var pauseLabel = toggle.querySelector('[data-kroq-video-label-pause]');
    var playLabel = toggle.querySelector('[data-kroq-video-label-play]');
    if (pauseLabel) pauseLabel.hidden = paused;
    if (playLabel) playLabel.hidden = !paused;
  }

  function wireToggle(root) {
    var toggle = root.querySelector('[data-kroq-video-toggle]');
    var video = root.querySelector('video');
    if (!toggle || !video) return;

    toggle.addEventListener('click', function () {
      if (video.paused) {
        play(video);
        setToggleState(root, false);
      } else {
        video.pause();
        setToggleState(root, true);
      }
    });

    // Sous reduced-motion la vidéo reste à l'arrêt : l'état initial du
    // bouton doit le refléter, pas annoncer une lecture qui n'a pas lieu.
    if (reduceMotion.matches) {
      video.pause();
      setToggleState(root, true);
    }
  }

  function init() {
    var roots = document.querySelectorAll('.kroq-bgvideo');
    if (!roots.length) return;

    var lazy = [];
    roots.forEach(function (root) {
      wireToggle(root);
      var video = root.querySelector('video');
      if (!video) return;

      if (root.hasAttribute('data-kroq-video-lazy')) {
        lazy.push(root);
      } else if (root.hasAttribute('data-kroq-video-priority')) {
        /* Déjà visible, donc pas d'observer — mais on laisse le poster
           tenir le premier écran. Attacher la source avant la fin du
           chargement ferait redescendre 832 ko dans la même bande
           passante et la vidéo redeviendrait l'élément LCP. */
        afterLoad(function () {
          activate(video);
        });
      } else {
        activate(video);
      }
    });

    if (!lazy.length) return;

    // Sans IntersectionObserver (navigateurs anciens), on charge tout de
    // suite plutôt que de laisser un fond vide.
    if (!('IntersectionObserver' in window)) {
      lazy.forEach(function (root) {
        activate(root.querySelector('video'));
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          activate(entry.target.querySelector('video'));
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '200px' }
    );

    lazy.forEach(function (root) {
      observer.observe(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
